import { useEffect, useRef } from 'react';

const IdleTimer = ({ timeout, onIdle }) => {
    const timerRef = useRef(null);

    const resetTimer = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            onIdle();
        }, timeout);
    };

    const handleUserActivity = () => {
        resetTimer();
    };

    useEffect(() => {
        const events = ['mousemove', 'keydown', 'scroll'];
        events.forEach(event =>
            window.addEventListener(event, handleUserActivity)
        );
        resetTimer();
        return () => {
            events.forEach(event =>
                window.removeEventListener(event, handleUserActivity)
            );
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [timeout, onIdle]);

    return null;

};

export default IdleTimer;
